import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, resolveDirective as _resolveDirective } from "vue";
import _imports_0 from '@/assets/svgs/ic-back.svg';
import _imports_1 from '@/assets/svgs/tax-loading.svg';
const _hoisted_1 = {
  class: "account-content"
};
const _hoisted_2 = {
  class: "button-container"
};
const _hoisted_3 = {
  key: 0,
  class: "hubspot-form-wrapper"
};
const _hoisted_4 = {
  class: "hubspot-form-container"
};
const _hoisted_5 = {
  key: 0,
  class: "hubspot-form-loading"
};
const _hoisted_6 = {
  class: "account-content"
};
const _hoisted_7 = {
  class: "button-container"
};
const _hoisted_8 = {
  class: "account-content"
};
const _hoisted_9 = {
  class: "button-container"
};
const _hoisted_10 = {
  class: "account-content"
};
const _hoisted_11 = {
  class: "button-container"
};
const _hoisted_12 = {
  class: "membership-content"
};
const _hoisted_13 = {
  class: "button-container"
};
import MembershipPrivilege from "@/components/membership-privilege";
import FleetsMembershipPrivilege from "@/components/fleets-membership-privilege";
import Step1 from "@/components/step-1";
import Step2 from "@/components/step-2";
import Step3 from "@/components/step-3";
import Step4 from "@/components/step-4";
import SuccessfulPage from "@/views/successful";
import SubscribedModal from "@/components/subscribed-modal";
import useNorthlandInsurance from "@/views/discount-membership/mixin";
import { reactive, ref } from "vue";
import { ACCOUNT_TYPE } from "@/const";
import { useProductStore } from "@/store/product";
export default /*@__PURE__*/Object.assign({
  name: "NorthlandInsuranceMobile"
}, {
  __name: 'mobile',
  setup(__props) {
    const productStore = useProductStore();
    const {
      step,
      accountType,
      buttonLoading,
      onAccountTypeChange,
      onStep2FormChange,
      onStep3FormChange,
      onStep4FormChange,
      handleContinue,
      handleBack,
      submit,
      hubspotFormLoading,
      handleFormBlur,
      isFormValid,
      isStep4Valid,
      taxLoading,
      taxAmount,
      showSuccessfulModal,
      showSubscribedModal,
      pageLoading
    } = useNorthlandInsurance();
    const step2_ref = ref(null);
    const step3_ref = ref(null);
    const step4_ref = ref(null);
    const rules = reactive({
      firstName: [{
        required: true,
        message: "Please input your first name."
      }],
      lastName: [{
        required: true,
        message: "Please input your last name."
      }],
      email: [{
        required: true,
        message: "Please input your email."
      }],
      phone: [{
        required: true,
        message: "Please input your phone number."
      }]
    });
    const step3Rules = reactive({
      address: [{
        required: true,
        message: "Please input your address."
      }],
      city: [{
        required: true,
        message: "Please input your city."
      }],
      postal: [{
        required: true,
        message: "Please input your postal code."
      }],
      country: [{
        required: true,
        message: "Please select your country."
      }],
      state: [{
        required: true,
        message: "Please select your state."
      }]
    });
    const handleContinueWithValidation = async value => {
      let isValid = true;
      try {
        if (step.value === 2) {
          isValid = await step2_ref.value?.validate();
        } else if (step.value === 3) {
          isValid = await step3_ref.value?.validate();
        } else if (step.value === 4) {
          isValid = await step4_ref.value?.validate();
        }
        if (isValid) {
          handleContinue(value);
        }
      } catch (error) {
        isValid = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_unref(Step1), {
        ref: "step1",
        "onUpdate:accountType": _unref(onAccountTypeChange)
      }, null, 8, ["onUpdate:accountType"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => _unref(handleContinue)(2))
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("Continue")])),
        _: 1,
        __: [11]
      })]), _createElementVNode("div", {
        class: "back",
        onClick: _cache[1] || (_cache[1] = $event => _unref(handleBack)(0))
      }, _cache[12] || (_cache[12] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createTextVNode(" Back ")]))], 512), [[_vShow, _unref(step) === 1]]), _unref(accountType) === _unref(ACCOUNT_TYPE).FLEET_MONTH ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "step2-title"
      }, [_createTextVNode("Step "), _createElementVNode("span", null, "2"), _createTextVNode(":")], -1)), _cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "form-title"
      }, "Fill out the form", -1)), _createElementVNode("div", _hoisted_4, [_unref(hubspotFormLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_icon, {
        class: "is-loading",
        size: "40"
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("img", {
          src: _imports_1,
          alt: "loading"
        }, null, -1)])),
        _: 1,
        __: [13]
      }), _cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "hubspot-form-loading-text"
      }, "Loading form...", -1))])) : _createCommentVNode("", true), _cache[15] || (_cache[15] = _createElementVNode("div", {
        id: "hubspot-form-container"
      }, null, -1))]), _createElementVNode("div", {
        class: "back",
        onClick: _cache[2] || (_cache[2] = $event => _unref(handleBack)(1))
      }, _cache[16] || (_cache[16] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createTextVNode(" Back ")]))], 512)), [[_vShow, _unref(step) === 2]]) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(_unref(Step2), {
        ref_key: "step2_ref",
        ref: step2_ref,
        rules: rules,
        "onUpdate:form": _unref(onStep2FormChange),
        "onUpdate:formBlur": _unref(handleFormBlur)
      }, null, 8, ["rules", "onUpdate:form", "onUpdate:formBlur"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => handleContinueWithValidation(3))
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("Continue")])),
        _: 1,
        __: [19]
      })]), _createElementVNode("div", {
        class: "back",
        onClick: _cache[4] || (_cache[4] = $event => _unref(handleBack)(1))
      }, _cache[20] || (_cache[20] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createTextVNode(" Back ")]))], 512), [[_vShow, _unref(step) === 2]]), _withDirectives(_createElementVNode("div", _hoisted_8, [_createVNode(_unref(Step3), {
        ref_key: "step3_ref",
        ref: step3_ref,
        rules: step3Rules,
        "onUpdate:form": _unref(onStep3FormChange),
        "onUpdate:formBlur": _unref(handleFormBlur)
      }, null, 8, ["rules", "onUpdate:form", "onUpdate:formBlur"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => handleContinueWithValidation(4))
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("Continue")])),
        _: 1,
        __: [21]
      })]), _createElementVNode("div", {
        class: "back",
        onClick: _cache[6] || (_cache[6] = $event => _unref(handleBack)(2))
      }, _cache[22] || (_cache[22] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createTextVNode(" Back ")]))], 512), [[_vShow, _unref(step) === 3]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createVNode(_unref(Step4), {
        ref: "step4",
        "onUpdate:form": _unref(onStep4FormChange),
        "tax-loading": _unref(taxLoading),
        "tax-amount": _unref(taxAmount),
        "is-form-valid": _unref(isFormValid),
        "product-info": _unref(productStore).membershipProductInfo
      }, null, 8, ["onUpdate:form", "tax-loading", "tax-amount", "is-form-valid", "product-info"]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
        loading: _unref(buttonLoading),
        type: "primary",
        onClick: _unref(submit),
        disabled: !(_unref(isFormValid) && _unref(isStep4Valid)) || _unref(taxLoading)
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("Place my order")])),
        _: 1,
        __: [23]
      }, 8, ["loading", "onClick", "disabled"])]), _createElementVNode("div", {
        class: "back",
        onClick: _cache[7] || (_cache[7] = $event => _unref(handleBack)(3))
      }, _cache[24] || (_cache[24] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createTextVNode(" Back ")]))], 512), [[_vShow, _unref(step) === 4]])], 64)), _withDirectives(_createElementVNode("div", _hoisted_12, [_unref(accountType) === _unref(ACCOUNT_TYPE).FLEET_MONTH ? (_openBlock(), _createBlock(_unref(FleetsMembershipPrivilege), {
        key: 0,
        "product-info": _unref(productStore).fleetProductInfo
      }, null, 8, ["product-info"])) : (_openBlock(), _createBlock(_unref(MembershipPrivilege), {
        key: 1,
        "product-info": _unref(productStore).membershipProductInfo
      }, null, 8, ["product-info"])), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[8] || (_cache[8] = $event => handleContinueWithValidation(1))
      }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("Continue")])),
        _: 1,
        __: [25]
      })])], 512), [[_vShow, _unref(step) === 0]]), _unref(showSuccessfulModal) ? (_openBlock(), _createBlock(_unref(SuccessfulPage), {
        key: 2
      })) : _createCommentVNode("", true), _createVNode(_unref(SubscribedModal), {
        modelValue: _unref(showSubscribedModal),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(showSubscribedModal) ? showSubscribedModal.value = $event : null),
        onClose: _cache[10] || (_cache[10] = $event => showSubscribedModal.value = false)
      }, null, 8, ["modelValue"])])), [[_directive_loading, _unref(pageLoading)]]);
    };
  }
});